import { IMultiStopsShipperRequest } from '../interfaces/order.interface';

export class Order {
  ProID: number;
  customerId: number;
  refNum: string;
  trailerNum: string;
  referenceContainer: string;
  shipperId: number;
  consigneeId: number;
  ponumber: string;
  boxSizeId?: number;
  orderTypeId: string;
  bolnumber: string;
  lesseeID: number;
  multiStopsShippersRequests: IMultiStopsShipperRequest[];
  originationRamp: string;
  terminationRamp: string;
  chgDray: number;
  fuelPercentage: number;
  fuelSurcharge: number;
  harborFee: number;
  harborFeePlacementFlag: string;
  applyFuelToHarbortermsFlag: boolean;
  chgMultiStopAdicional: number;
  amtDue: number;
  chgTotal: number;
  statusTripID: number;
  isFullTrip: boolean;

  constructor() {
    this.customerId = null;
    this.refNum = null;
    this.trailerNum = null;
    this.referenceContainer = null;
    this.shipperId = null;
    this.consigneeId = null;
    this.ponumber = null;
    this.boxSizeId = null;
    this.orderTypeId = null;
    this.bolnumber = null;
    this.lesseeID = null;
    this.multiStopsShippersRequests = [];
    this.originationRamp = null;
    this.terminationRamp = null;
    this.chgDray = 0;
    this.fuelPercentage = null;
    this.fuelSurcharge = null;
    this.chgMultiStopAdicional = null;
    this.amtDue = null;
    this.chgTotal = null;
    this.isFullTrip = false;
    this.statusTripID = 0;
  }
}

export class OrderFilters {
  ProId?: number;
  StatusId?: number;
  StatusTripId?: number;
  DateRange: Date[];
  CustomerId?: number;
  OrderTypeId?: string;
  ShipperId?: number;
  ReferenceContainer?: string;
  ConsigneeId?: number;
  Bolnumber?: string;
  RefNum?: number;

  constructor() {
    this.ProId = null;
    this.StatusId = null;
    this.StatusTripId = null;
    this.DateRange = [];
    this.CustomerId = null;
    this.OrderTypeId = null;
    this.ShipperId = null;
    this.ReferenceContainer = null;
    this.ConsigneeId = null;
    this.Bolnumber = null;
    this.RefNum = null;
  }

  buildRequest(): any {
    return {
      ProId: this.ProId,
      StatusId: this.StatusId,
      ID:
        +this.StatusId == 2 && this.DateRange?.length == 2 // Invoiced State
          ? `${this.DateRange[0]},${this.DateRange[1]}`
          : null,
      CustomerId: this.CustomerId,
      OrderTypeId: this.OrderTypeId,
      ShipperId: +this.ShipperId,
      ReferenceContainer: this.ReferenceContainer,
      RefNum: this.RefNum,
      DC:
        this.StatusId != 2 && this.DateRange?.length == 2 // Date Created
          ? `${this.DateRange[0]},${this.DateRange[1]}`
          : null,
      ConsigneeId: this.ConsigneeId,
      Bolnumber: this.Bolnumber,
    };
  }
}

export class DrayCalculation {
  chgDray: number;
  fuelSurcharge: number;
  harborFee: number;
  harborFeePlacement: string;
  fuelPercent: number;
  applyFuelToHarbortermsFlag: boolean;
}

export class OrderPaymentDetail {
  checkAmt: number;
  DateRec: Date;
  proId: number;
  customer: string;
  clientReference: string;
  trailer: string;
  chgTotal: number;
  amountDue: number;
  amountPaid: number;
  amountWriteOff: number;
  statusId: number;
  CheckTransId: number;
  CheckNumber: string;
  status: string;
}

export class ChargesResume {
  ProId: number;
  Charges: string;
  OrderAmount: number;
}

export class PrintTicketStopsConsignee {
  proID: number;
  consigneeName: string;
  consigneeAddress: string;
  consigneeCity: string;
  consigneeState: string;
  zip: string;
}

//#region --> MULTI STOPS

export class MultiStopResponse {
  consigneeName: string;
  shipperName: string;
  proID: number;
  consigneeID: number;
  shipperID: number;
  orderTypeID: number;
  seqNo: number;
  TimeIn: string;
  TimeOut: string;
  Pieces: number;
  Weight: number;
  SealNumber: string;
  PONumber: string;
  AppointmentNumber: string;
  ReleaseNumber: string;
  PickupNumber: string;
  apptDate: Date;
  earlyTime: string;
  lateTime: string;
  notes: string;
  multiStopsId: number;
  Amount: number;
  amountCalculatedByBackend: boolean;
}

export class RegisterMultiStopReq {
  multiStopsId: number;
  seqNo: number;
  consigneeID?: number;
  shipperID?: number;
  appointmentNumber?: string;
  apptDate?: string;
  pickupNumber?: string;
  releaseNumber?: string;
  poNumber?: string;
  amount: number;
  amountCalulatedByBackend: boolean;
}

export class DeleteMultiStopReq {
  proId: number;
  multiStopsId?: number;
  amountCalculatedByBackend?: boolean;
  amount?: number;
}

//#endregion

//#region --> QUICK POST
export class QuickLesseePost {
  name: string;
  active: boolean;
  constructor() {
    this.name = null;
    this.active = true;
  }
}

export class QuickCustomerPost {
  name: string;
  addr1: string;
  addr2: string;
  city: string;
  // state: string;
  zip: string;
  phOffice: string;
  phFax: string;
  notes: string;
  email: string;
  contact: string;

  constructor() {
    this.name = null;
    this.addr1 = null;
    this.addr2 = null;
    this.city = null;
    this.zip = null;
    this.phOffice = null;
    this.phFax = null;
    this.notes = null;
    this.email = null;
    this.contact = null;
  }
}

export class QuickShipperPost {
  email: string;
  name: string;
  addr1: string;
  addr2: string;
  cityId: string;
  stateId: string;
  zipcode: string;
  phOffice: string;
  phFax: string;
  phExt: string;
  contact: string;
  deliveryTime: string;
  notes: string;

  constructor() {
    this.email = null;
    this.name = null;
    this.addr1 = null;
    this.addr2 = null;
    this.cityId = null;
    this.stateId = null;
    this.zipcode = null;
    this.phOffice = null;
    this.phFax = null;
    this.phExt = null;
    this.contact = null;
    this.deliveryTime = null;
    this.notes = null;
  }
}

export class QuickConsigneePost {
  name: string;
  addr1: string;
  addr2: string;
  stateId: string;
  zipcode: string;
  phOffice: string;
  phFax: string;
  phExt: string;
  contact: string;
  notes: string;
  email: string;
  deliveryTime: string;
  cityId: number;

  constructor() {
    this.name = null;
    this.addr1 = null;
    this.addr2 = null;
    this.stateId = null;
    this.zipcode = null;
    this.phOffice = null;
    this.phFax = null;
    this.phExt = null;
    this.contact = null;
    this.notes = null;
    this.email = null;
    this.deliveryTime = null;
    this.cityId = null;
  }
}

export class QuickRampPost {
  name: string;
  addr1: string;
  addr2: string;
  stateId: string;
  rampZipcode: string;
  notes: string;
  cityId: number;
  rateId: number;

  constructor() {
    this.name = null;
    this.addr1 = null;
    this.addr2 = null;
    this.stateId = null;
    this.rampZipcode = null;
    this.notes = null;
    this.cityId = null;
    this.rateId = null;
  }
}

//#endregion
